import {URL} from 'components/Fields';

const Grpc = () => <URL showMethodSelector={false} />;

export default Grpc;
